<template>
  <div class="multifunctional-input" :class="{'error': hasError, 'disabled': isDisabled}">
    <div class="before-text k-body-md" v-if="beforeText">{{ beforeText }}</div>
    <input type="text" class="k-body-md" :value="value" @input="onInput($event.target.value)" :placeholder="placeholder">
  </div>
</template>

<script>
export default {
  props: {
    beforeText: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    hasError: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  methods: {
    onInput(value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="less" scoped>
.multifunctional-input {
  display: flex;
  align-items: center;
  padding: 13px 12px;
  box-sizing: border-box;
  border-radius: 8px;
  border: 1px solid var(--kk-color-border-light);

  .before-text {
    max-width: 50%;
  }
  input {
    flex: 1;
    border: none;
    outline: none;
    padding: 0;
    font-size: 14px;
    &::placeholder {
      color: var(--kk-color-text-light);
    }
  }
  &:hover {
    border-color: #212121;
  }
}
.error {
  border-color: var(--kk-color-text-critical-dark);
}
.disabled {
  border-color: var(--kk-color-background-surface-medium);
  background-color: var(--kk-color-background-surface-light);
  cursor: no-drop;
  pointer-events: none;
  .before-text {
    color: var(--kk-color-text-medium);
  }
  input {
    color: var(--kk-color-text-medium);
    background-color: var(--kk-color-background-surface-light);
  }
}
</style>
